<script lang="ts" setup>
import type { DeepReadonly } from 'vue';
import type { BlockSerializedChild, BlockSerializedSlotOutlet } from '#layers/block-engine/types/block';
import type { BlockInheritSlots } from '#layers/block-engine/types/block-editor';
import { isBlockSerializedChild, isBlockSerializedSlotOutlet } from '#layers/block-engine/utils/block/editor';

const props = defineProps<{
	children: Array<DeepReadonly<BlockSerializedChild | BlockSerializedSlotOutlet>>;
	parent?: BlockSerializedChild;
	slotName?: string;
}>();

defineSlots<Slots>();

interface Slots extends BlockInheritSlots {
	'before-child': (props: {
		index: number;
	}) => any;
}
</script>

<template>
	<template
		v-for="(child, index) of props.children"
		:key="child.id"
	>
		<slot name="before-child" :index />

		<BlockEditorRenderChild
			v-if="isBlockSerializedChild(child)"
			:child
			:slot-name
			:index
		>
			<template #add-block="slotProps">
				<slot
					name="add-block"
					v-bind="slotProps"
				/>
			</template>

			<template #preview-block="slotProps">
				<slot
					name="preview-block"
					v-bind="slotProps"
				/>
			</template>

			<template #outlet="slotProps">
				<slot
					name="outlet"
					v-bind="slotProps"
				/>
			</template>
		</BlockEditorRenderChild>

		<slot
			v-else-if="isBlockSerializedSlotOutlet(child)"
			name="outlet"
			:outlet="child"
		/>
	</template>
</template>
